import { colors, getColor, hexToRGBA } from '@/context/colors';
import { darkColorPalette, lightColorPalette } from '@/theme';

export const colorPalette = {
  system: { primary: getColor('purpleHeart') },
  background: {
    primary: getColor('shark'),
    secondary: getColor('mulledWine'),
    backgroundElements: getColor('daisyBush'),
    loginModal: getColor('woodSmoke'),
  },
  stroke: { loginModal: getColor('balticSea') },
  text: {
    primary: darkColorPalette.dmWhite,
    secondary: getColor('portage'),
    highlight: {
      background: getColor('russianViolet'),
      border: getColor('lavenderBlue'),
    },
  },
  card: {
    path: getColor('portage'),
    border: {
      primary: getColor('mulledWine'),
      hover: {
        color: getColor('mulledWine'),
        shadow: getColor('white', 0.1),
      },
    },
    background: {
      primary: getColor('woodSmoke'),
      hover: getColor('codGray'),
    },
  },
  alert: {
    warning: {
      text: getColor('sunglow'),
      background: getColor('sunglow', 0.1),
    },
    error: {
      text: getColor('chestnutRose'),
      background: getColor('chestnutRose', 0.1),
    },
    success: { text: getColor('fern'), background: getColor('fern', 0.1) },
  },
  button: {
    contained: {
      background: {
        active: getColor('cornflowerBlue'),
        hover: getColor('studio'),
        disabled: getColor('portGore'),
      },
      text: { active: getColor('white'), disabled: getColor('riverBed') },
    },
    outlined: {
      background: { hover: getColor('haiti') },
      stroke: {
        active: getColor('purpleHeart'),
        disabled: getColor('meteorite'),
      },
      text: { active: getColor('white'), disabled: getColor('riverBed') },
    },
    text: {
      background: { hover: getColor('purpleHeart', 0.8) },
      stroke: {
        active: getColor('purpleHeart'),
        disabled: getColor('meteorite'),
      },
      text: { active: getColor('portage'), disabled: getColor('daisyBush') },
    },
    secondary: {
      text: { active: getColor('white') },
      stroke: {
        active: getColor('purpleHeart'),
      },
    },
  },
  components: {
    checkbox: {
      disabled: {
        border: darkColorPalette.dmDarkPurple,
        color: darkColorPalette.dmMediumGrey,
        background: darkColorPalette.dmBackgroundDarkest,
        hover: {
          background: darkColorPalette.dmBackgroundDarkest,
        },
      },
      enabled: {
        background: darkColorPalette.dmBackgroundDarkest,
        border: darkColorPalette.dmMediumPurple,
        color: darkColorPalette.dmWhite,
        hover: {
          background: hexToRGBA(darkColorPalette.dmMediumPurple, 0.5),
        },
      },
    },
    Search: {
      icon: {
        color: getColor('white'),
        border: getColor('brightLavender'),
        background: {
          primary: getColor('transparent'),
          withValue: getColor('spanishViolet'),
          hover: getColor('brightLavender'),
        },
      },
      border: getColor('slateBlue'),
      text: {
        primary: getColor('white'),
        placeholder: getColor('chineseSilver'),
      },
      background: getColor('russianViolet'),
    },
    AlertToast: {
      color: getColor('white'),
      background: {
        info: getColor('japaneseIndigo'),
        success: getColor('darkJungelGreen'),
        warning: getColor('bistre'),
        error: getColor('brownCoffee'),
      },
      border: {
        info: getColor('dodgeBlue'),
        success: getColor('emarald'),
        warning: getColor('deepSaffron'),
        error: getColor('redRyb'),
      },
    },
    ProviderBoxesView: {
      ProviderName: {
        color: getColor('selago'),
      },
      ProviderWrapper: {
        border: { color: lightColorPalette.lbBlue_20 },
        disabled: {
          backgroundColor: getColor('zircon'),
        },
        hover: {
          border: { color: getColor('white') },
          background: { color: getColor('white', 0.055) },
        },
      },
      CheckedProvider: {
        backgroundColor: getColor('titanWhite'),
        border: { color: getColor('melrose') },
      },
    },
    accountSettings: {
      background: { primary: getColor('eerieBlack') },
      text: {
        primary: getColor('white'),
        logout: getColor('melrose'),
      },
      avatar: {
        background: getColor('copperRed'),
        backgroundElement: getColor('black'),
        text: getColor('white'),
      },
      border: getColor('mulledWine'),
      orgsSelector: {
        check: getColor('melrose'),
        text: getColor('white'),
        checkSign: getColor('mulledWine'),
      },
      separator: getColor('mulledWine'),
    },
    dashboard: {
      graph: {
        background: getColor('woodSmoke'),
      },
      tooltip: {
        text: getColor('silverSand'),
        background: getColor('woodSmoke'),
        border: getColor('mulledWine'),
        boxShadow: getColor('white', 0.15),
      },
      periodSelector: {
        border: getColor('blueViolet'),
        selected: getColor('spanishViolet'),
      },
    },
    DropDown: {
      border: {
        color: getColor('fuchsiaBlue'),
      },
      icon: {
        color: getColor('silverSand'),
      },
      background: { color: getColor('woodSmoke') },
      item: {
        hover: {
          color: getColor('steelGray'),
        },
        selected: { color: getColor('russianViolet') },
      },
      hover: {
        background: {
          color: hexToRGBA(getColor(colors.fuchsiaBlue), 0.6),
        },
      },
    },
    BetaTag: {
      background: getColor(colors.brightLavender),
      color: getColor(colors.woodSmoke),
    },
    Loader: {
      color: getColor(colors.brightLavender),
    },
  },
};
